import React from "react"
import styled from "styled-components"
import intention from "../../images/btc-meditation.png"

import { Section, Container } from "../global"

const PERKS = [
  {
    emoji: "🎡",
    title: "Spin the wheel",
    text: "Every day you add, spin for BTC points. Showing up always pays something.",
  },
  {
    emoji: "🔥",
    title: "Streak bonuses",
    text: "Keep your streak alive and your rewards grow with it.",
  },
  {
    emoji: "🌟",
    title: "Golden suns",
    text: "Rare, shiny, and worth extra. When one lands, you'll know.",
  },
  {
    emoji: "⚡",
    title: "Real sats payouts",
    text: "Points become real Bitcoin, paid out in sats. No fees, ever.",
  },
]

const Bitcoin = () => (
  <StyledSection id="bitcoin">
    <StyledContainer>
      <Subtitle>The kicker</Subtitle>
      <SectionTitle>Show up, earn Bitcoin</SectionTitle>
      <LeadText>
        Day rewards your consistency with Bitcoin — a little treat for showing
        up, not an investment scheme. The habit is the prize; the sats are the
        cherry on top.
      </LeadText>
      <BitcoinGrid>
        <PerksColumn>
          {PERKS.map((perk) => (
            <Perk key={perk.title}>
              <PerkEmoji>{perk.emoji}</PerkEmoji>
              <div>
                <PerkTitle>{perk.title}</PerkTitle>
                <PerkText>{perk.text}</PerkText>
              </div>
            </Perk>
          ))}
        </PerksColumn>
        <ImageColumn>
          <img src={intention} alt="Meditating with Bitcoin" />
        </ImageColumn>
      </BitcoinGrid>
      <Disclaimer>
        Day is a rewards app, not financial advice. Bitcoin rewards are a perk
        for daily practice — nothing here is investment guidance.
      </Disclaimer>
    </StyledContainer>
  </StyledSection>
)

export default Bitcoin

const StyledSection = styled(Section)`
  background: linear-gradient(180deg, #fffdf8 0%, #fff2d6 100%);
`

const StyledContainer = styled(Container)``

const SectionTitle = styled.h3`
  color: ${(props) => props.theme.color.primary};
  display: flex;
  justify-content: center;
  margin: 0 auto 16px;
  text-align: center;
`

const Subtitle = styled.h5`
  font-size: 16px;
  color: ${(props) => props.theme.color.accent};
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-bottom: 12px;
  text-align: center;
`

const LeadText = styled.p`
  max-width: 560px;
  margin: 0 auto 48px;
  text-align: center;
  color: ${(props) => props.theme.color.black.light};
  font-size: 18px;
  line-height: 28px;
`

const BitcoinGrid = styled.div`
  max-width: 900px;
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  align-items: center;
  margin: 0 auto;
  grid-column-gap: 48px;
  @media (max-width: ${(props) => props.theme.screen.sm}) {
    grid-template-columns: 1fr;
    grid-row-gap: 32px;
    padding: 0 32px;
  }
`

const PerksColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

const Perk = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-start;
  background: white;
  border: 1px solid #ffe9c7;
  border-radius: 16px;
  padding: 18px 20px;
`

const PerkEmoji = styled.div`
  font-size: 26px;
  line-height: 1;
  margin-top: 2px;
`

const PerkTitle = styled.h4`
  color: ${(props) => props.theme.color.primary};
  margin: 0 0 4px;
`

const PerkText = styled.p`
  margin: 0;
  color: ${(props) => props.theme.color.black.light};
  line-height: 22px;
`

const ImageColumn = styled.div`
  display: flex;
  justify-content: center;

  img {
    max-height: 260px;
    width: auto;
    max-width: 100%;
  }
`

const Disclaimer = styled.p`
  max-width: 560px;
  margin: 40px auto 0;
  text-align: center;
  font-size: 13px;
  color: ${(props) => props.theme.color.black.lightest};
`
